export default __webpack_public_path__ + "static/media/main5.fae25f6a.jpg";